// extracted by mini-css-extract-plugin
export default {"text":"LogoutModal_text__6iLSK","btns_container":"LogoutModal_btns_container__auMUU","cancel_btn":"LogoutModal_cancel_btn__mQm8+","submit_btn":"LogoutModal_submit_btn__JUNW2"};